import { SxProps } from '@mui/system';

export const MainBoxStyle = {
  display: 'flex',
  flexDirection: 'row',
  width: 'calc(100%-10px)',
  alignItems: 'center',
  marginRight: '5px',
  marginLeft: '5px',
  paddingTop: '5px',
  paddingBottom: '5px',
  gap: '2em',
} as SxProps;
